export const REPLACE_CLIENTS = 'REPLACE_CLIENTS';
export const ADD_CLIENT = 'ADD_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';